import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import DashboardGrid from '../../../../components/Dashboard/DashboardGrid';
import { Pivot, PivotItem } from '@fluentui/react';
import StorefrontOrdersTable from '../../../../components/Storefront/Orders/StorefrontOrdersTable';
import StorefrontCartsTable from '../../../../components/Storefront/Carts/StorefrontCartsTable';
import PreparedCartsTable from '../../../../components/Storefront/PreparedCart/PreparedCartsTable';

const StorefrontGlobalDashboardPage: React.FC<RouteComponentProps> = () => {
    return (
        <div>
            <h1>Storefront</h1>
            <Pivot>
                <PivotItem headerText='Dashboard'>
                    <DashboardGrid resource="storefront" />
                </PivotItem>
                <PivotItem headerText='Orders'>
                    <StorefrontOrdersTable />
                </PivotItem>
                <PivotItem headerText='Customer Carts'>
                    <StorefrontCartsTable />
                </PivotItem>
                <PivotItem headerText='Prepared Carts'>
                    <PreparedCartsTable />
                </PivotItem>
            </Pivot>
        </div>
    );
};

export default StorefrontGlobalDashboardPage;
